import {
	type LayoutNavComponentProps,
	SvgFromUrl,
	TrackingLink,
} from '@ds-mgnl/marketing';
import { classNames } from '@dsx/react';
import logoSvg from '../assets/images/tels-logo.svg';
import styles from './TelsLogo.module.css';

export type TelsLogoProps = LayoutNavComponentProps;

export function TelsLogo({ transparent }: TelsLogoProps) {
	return (
		<TrackingLink href="/" clickType="header_link" trackingText="Top Nav Logo">
			<SvgFromUrl
				url={logoSvg}
				height={'37px'}
				className={classNames(styles['logo'], {
					[styles['transparent']]: transparent,
				})}
			/>
		</TrackingLink>
	);
}
